import { render, staticRenderFns } from "./LoanStatusTag.vue?vue&type=template&id=295720a2"
import script from "./LoanStatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanStatusTag.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports